<template>
    <div
        v-if="analytics.meetingDistribution.amountTotal > 0"
        class="tw-grid tw-gap-4 xl:tw-gap-12 tw-auto-rows-max tw-grid-cols-1 xl:tw-grid-cols-3"
    >
        <div class="tw-col-span-2">
            <l-meeting-analytics-distribution-chart
                :height="180"
                :timelines="analytics.timelines"
                :time-unit="timeUnit"
            />
        </div>

        <div class="tw-flex tw-flex-col tw-items-center tw-justify-center">
            <div class="tw-flex tw-w-full tw-justify-center tw-items-start">
                <div class="tw-flex-1 tw-text-center">
                    <div
                        class="tw-w-16 tw-h-16 tw-bg-white tw-border-2 tw-border-solid tw-border-gray-50 tw-rounded-full tw-shadow tw-inline-flex tw-items-center tw-justify-center"
                    >
                        <i class="far fa-user" />
                    </div>
                    <div class="tw-mt-4 tw-font-bold tw-text-2xl">
                        {{ Math.round(percentages.typeIndividual.toFixed(2)) }}%
                    </div>
                    <span class="tw-text-xs tw-text-gray-400">
                        {{ $t("meetings.analytics.insights.distribution.individualMeetings") }}
                    </span>
                </div>

                <div class="tw-flex-1 tw-text-center">
                    <div
                        class="tw-w-16 tw-h-16 tw-bg-white tw-border-2 tw-border-solid tw-border-indigo-50 tw-rounded-full tw-shadow tw-inline-flex tw-items-center tw-justify-center"
                    >
                        <i class="far fa-users" />
                    </div>
                    <div class="tw-mt-4 tw-font-bold tw-text-2xl">
                        {{ Math.round(percentages.typeTeam.toFixed(2)) }}%
                    </div>
                    <span class="tw-text-xs tw-text-gray-400">
                        {{ $t("meetings.analytics.insights.distribution.teamMeetings") }}
                    </span>
                </div>
            </div>

            <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-mt-6">
                <div
                    class="tw-bg-gray-100 tw-h-6 tw-w-full tw-relative tw-rounded-md tw-overflow-hidden"
                >
                    <div
                        class="tw-bg-gray-200 tw-h-6 tw-absolute tw-left-0"
                        :style="`width: ${percentages.completed}%`"
                    ></div>
                    <div
                        class="tw-bg-gray-100 tw-h-6 tw-absolute"
                        :style="`width: ${percentages.pending}%; left: ${percentages.completed}%;`"
                    ></div>
                </div>

                <div class="tw-flex tw-items-center tw-justify-center tw-text-xs tw-text-gray-400">
                    <div class="tw-mt-4 tw-px-4">
                        <span
                            class="tw-inline-block tw-h-2 tw-w-2 tw-rounded-full tw-bg-gray-200 tw-mr-2"
                        />
                        {{ Math.round(percentages.completed.toFixed(2)) }}%
                        {{ $t("meetings.analytics.insights.distribution.completed") }}
                    </div>
                    <div class="tw-mt-4 tw-px-6">
                        <span
                            class="tw-inline-block tw-h-2 tw-w-2 tw-rounded-full tw-bg-gray-100 tw-mr-2"
                        />
                        {{ Math.round(percentages.pending.toFixed(2)) }}%
                        {{ $t("meetings.analytics.insights.distribution.pending") }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LMeetingAnalyticsDistributionChart from "@/components/LMeetingAnalytics/LMeetingAnalyticsDistributionChart";

export default {
    components: {
        LMeetingAnalyticsDistributionChart,
    },
    props: {
        timeUnit: {
            type: String,
            default: "month",
        },
        analytics: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        percentages() {
            let data = {
                typeTeam: 0,
                typeIndividual: 0,
                completed: 0,
                pending: 0,
            };

            if (!this.analytics?.meetingDistribution?.amountTotal) return data;

            const numbers = this.analytics.meetingDistribution;
            const total = numbers.amountTotal;
            data = {
                typeTeam: (numbers.amountTypeTeam * 100) / total,
                typeIndividual: (numbers.amountTypeIndividual * 100) / total,
                completed: (numbers.amountCompleted * 100) / total,
                pending: (numbers.amountPending * 100) / total,
            };

            return data;
        },
    },
};
</script>
